export const CUSTOM_DISCLAIMER_FIELD_LIMITS = {
  name: 100,
  organisationName: 100,
  text: 1000,
} as const;

export const CUSTOM_DISCLAIMERS_API_PATH = '/custom-disclaimers';

export const CUSTOM_DISCLAIMERS_ENROLLMENT_LINK_API_PATH =
  `${CUSTOM_DISCLAIMERS_API_PATH}/onboarding/consent-url`;

export const CUSTOM_DISCLAIMER_DELIVERY_COOLDOWN_SECONDS = 86400;

export const CUSTOM_DISCLAIMERS_REQUIRED_PERMISSIONS = [
  'Chat.Read.All',
  'ChatMessage.Send',
  'openid',
  'profile',
  'offline_access',
];